import { Divider, Grid, Input, TextareaAutosize, TextField } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import Header from "./Header";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import GetAppIcon from '@material-ui/icons/GetApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import AOS from 'aos';
import 'aos/dist/aos.css';
import zIndex from "@material-ui/core/styles/zIndex";

const useStyles = makeStyles((theme) => ({
  body: {
    backgroundColor: "black",
    fontFamily: "'Montserrat', sans-serif",
    height: "auto",
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000000",
  },
  subdiv: {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
    borderRadius: "18px",
  },
  icons: {
    color: "#dfe6e9",
    border: ".5px solid #fdcb6e",
    borderRadius: "2em",
    padding: 10,
    margin: 10,
    fontSize: "32px",
    cursor: "pointer",
    "&:hover": {
      transition: "all 1.5s ease-in-out",
      transform: "rotate(1turn)",
      color: "black",
      backgroundColor: "#fdcb6e",
    },
    "@media (max-width: 768px)":{
      fontSize: "16px"
    }
  },
  icons1: {
    color: "#dfe6e9",
    textDecoration: "none",
    border: "1px solid #fdcb6e",
    borderRadius: "1em",
    padding: "1em 5.5em 1em 4.5em",
    marginRight: "1.5em",
    fontSize: "18px",
    cursor: "pointer",
    letterSpacing:2.5,
    "&:hover": {
      transition: "all 1.5s ease-in-out",
      color: "black",
      backgroundColor: "#fdcb6e",
    },
    "@media (max-width: 768px)":{
      fontSize: '12px',
      padding: "0.3em 2em 0.3em 2em",
      alignSelf: 'center',
      marginRight: "4em",
    }
  },
  card: {
    border: "1px solid #fdcb6e",
    height: "49vh",
    margin: "3em",
  },
  card1: {
    border: "1px solid #fdcb6e",
    height: "50vh",
    margin: "3em",
    marginTop: "4em",
    position: "relative",
    "@media (max-width: 768px)":{
      width:'fit-content'
    }
  },
  progress: {
    marginTop: "1em",
    padding: '0.1em 0.1em 0em 0.2em',
    height:'2.7vh',
    background: "transparent",
    borderRadius: 15,
    border: "1px solid #fdcb6e",
    width: "54%",
  },
  fill: {
    border: "1px solid #fdcb6e",
    backgroundColor: "#fdcb6e",
    height: "2vh",
    width: "85%",
    borderRadius: 10,
  },
  input:{
    color:'#ffffff',
    borderBottom:'1px solid #0984e3',
    width:'30vw',
    marginBottom:'3em',
  },
  input1:{
    color:'#ffffff',
    width:'30vw',
    backgroundColor:'#000000',
    border:'1px solid #0984e3',
    fontFamily: "'Montserrat', sans-serif",
    outline:'none',
    fontSize:'16px',
    padding:5
  },
  projecttitle:{
    color: '#ffffff',
    fontSize: "25px",
    position: "absolute",
    top: "5.5em",
    left: "7.5em",
    backgroundColor: "#16a085",
    padding: "1em",
    "@media (max-width: 768px)":{
      fontSize: '20px',
      left: '6em',
      top: '8em'
    }
  },
  img1:{
    height: "78vh",
    borderTopLeftRadius: "2.2em",
    borderBottomRightRadius: "2.2em",
    border: ".5em solid",
    marginBottom: "1em",
    '@media (max-width: 768px)':{
      height: 'fit-content',
    }
  },
  detail:{
    marginRight: "3em",
    "@media (max-width: 768px)":{
      marginTop:'0em'
    } 
  },
  about:{
    color: "#ffffff",
    fontSize: "40px",
    letterSpacing: "2px",
    marginBottom: "0.3em",
    "@media (max-width: 768px)":{
      fontSize: "26px"
    }
  },
  line:{
    backgroundColor: "#fbc531",
    width: "12vw",
    marginLeft: "14em",
    '@media (max-width: 768px)':{
      marginLeft:'5.7em'
    }
  },
  name:{
    color: "#b2bec3",
    letterSpacing: "2px",
    fontSize: "26px",
    marginTop: "1em",
    '@media (max-width: 768px)':{
      fontSize: "18px"
    }
  },
  position:{
    color: "#b2bec3",
    marginTop: "-0.5em",
    letterSpacing: "2px",
    '@media (max-width: 768px)':{
      fontSize: '16px'
    }
  },
  para:{
    color: "#ffff",
    fontWeight: "100px",
    margin: "3em",
    fontSize: "17px",
    lineHeight: "1.7em",
    letterSpacing: "1px",
    marginTop: "1em",
    "@media (max-width: 768px)":{
      fontSize: '12px'
    }
  },
  heading2:{
    color: "#ffffff",
    fontSize: "40px",
    letterSpacing: "2px",
    marginBottom: "0.3em",
    "@media (max-width: 768px)":{
      fontSize: '26px'
    }
  },
  img2:{
    width: "41.5vw", 
    height: "50vh",
    "@media (max-width: 768px)":{
      width: '60vw',
    }
  },
  project:{
    "@media (max-width: 768px)":{
      marginLeft: '4.5em'
    }
  },
  heading3:{
    color: "#ffffff",
    fontSize: "40px",
    letterSpacing: "2px",
    marginBottom: "0.3em",
    "@media (max-width: 768px)":{
      fontSize: '26px'
    }
  },
  heading4:{
    color: "#ffffff",
    fontSize: "44px",
    letterSpacing: "2px",
    marginBottom: "0.3em",
    "@media (max-width: 768px)":{
      fontSize: '26px'
    }
  }
}));

export default function PortfolioCard(props) {
  const classes = useStyles();
  const mystyle={
    backgroundImage: 'linear-gradient(to right, #430089, #82ffa1) url(../images/foodzoneproj.png)'
  }
  
  useEffect(()=>{
    AOS.init({ duration: 3000 })
  },[]);

  return (
    <div className={classes.body}>
      <Header />
      <div className={classes.root}>
        <div className={classes.subdiv}>
          <Grid container spacing={1} data-aos="fade-down" id={'section1'} style={{marginTop:'8em'}}>
            <Grid item xs={12} sm={6}>
              <img
                src="./developericon.webp"
                className={classes.img1}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <div  className={classes.detail}>
                <div>
                  <h2
                    className={classes.about}
                  >
                    ABOUT
                  </h2>
                  <Divider
                    className={classes.line}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <h2
                    className={classes.name}
                  >
                    Himanshi Jain
                  </h2>
                  <h3
                    className={classes.position}
                  >
                    Frontend Developer
                  </h3>
                </div>
                <LinkedInIcon className={classes.icons} />
                <GitHubIcon className={classes.icons} />
                <FacebookIcon className={classes.icons} />
                <InstagramIcon className={classes.icons} />

                <p
                  className={classes.para}
                >
                  I am passionate about designing different types of websites
                  and layouts. And my top most Frontend Skills are HTML, CSS,
                  React JS and Bootstrap.
                </p>
              </div>
              <a
                href="./images/HimanshiJain-2021(1).pdf"
                className={classes.icons1}
                download="HimanshiJain-2021(1)"
              >
                <span>Download  
                  {/* <GetAppIcon style={{position:'absolute',top:'24.2em'}}/> */}
                </span>
              </a>
            </Grid>

            {/* ----------------mywork------------------------ */}


            <Grid items xs={12}  data-aos="fade-up" id={'section2'} style={{ marginTop: "3em"}}>
              <h2
                className={classes.heading2}
              >
                My Work
              </h2>
              <Divider
                style={{
                  backgroundColor: "#fbc531",
                  width: "15.5vw",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </Grid>
            {/* <Grid items xs={12} sm={6} data-aos="fade-up">
              <span>FOODZONE</span>
              <div className={classes.card}>
                <div style={{ color: "#ffff" }} style={mystyle}>
                  <img
                    src="./images/foodzoneproj.png"
                    style={{ height: "49vh"}}
                    data-aos="flip-right"
                  />
                </div>
              </div>
            </Grid> */}
            <Grid items xs={12} sm={6} data-aos="fade-up" className={classes.project}>
              <div className={classes.card1}>
                <div style={{ color: "#ffff" }}>
                  <img
                    src="./images/game1proj.jpg"
                    className={classes.img2}
                    data-aos="flip-left"
                  />
                </div>
                <a href="https://github.com/himanshi1707/GameZone-ClientSide">
                  <span className={classes.projecttitle}>
                    GameZone
                  </span>
                </a>
              </div>
            </Grid>

            {/*-------------------------- Skills and Languages-------------------------- */}

            <Grid items xs={12} data-aos="fade-up" id={'section3'} style={{marginTop: "5em"}}>
              <h2
                style={{
                  
                }}
                className={classes.heading3}
              >
                Skills & Languages
              </h2>
              <Divider
                style={{
                  backgroundColor: "#fbc531",
                  width: "33vw",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </Grid>
            <Grid items xs={12} sm={6} data-aos="fade-up" style={{ margin: "2em" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent:'center',
                  gap:'7.5em',
                  marginBottom: "2em",
                  width: "90vw",
                }}
              >
                <img src="./images/html2.svg" style={{ height: "10vh" }} />
                <div className={classes.progress}>
                  <div className={classes.fill}></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent:'center',
                  gap:'7.5em',
                  marginBottom: "2em",
                  width: "90vw",
                }}
              >
                <img src="./images/css3-logo.png" style={{ height: "10vh" }} />
                <div className={classes.progress}>
                  <div className={classes.fill} style={{ width: "60%" }}></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent:'center',
                  gap:'7.5em',
                  marginBottom: "2em",
                  flexDirection: "row",
                  width: "90vw",
                }}
              >
                <img
                  src="./images/javascript-icon.jpg"
                  style={{ height: "10vh" }}
                />
                <div className={classes.progress}>
                  <div className={classes.fill} style={{ width: "60%" }}></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent:'center',
                  gap:'7.5em',
                  marginBottom: "2em",
                  width: "90vw",
                }}
              >
                <img src="./images/react1.png" style={{ height: "10vh" }} />
                <div className={classes.progress}>
                  <div className={classes.fill} style={{ width: "45%" }}></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent:'center',
                  gap:'7.5em',
                  marginBottom: "2em",
                  width: "90vw",
                }}
              >
                <img src="./images/bootstrap.svg" style={{ height: "10vh" }} />
                <div className={classes.progress}>
                  <div className={classes.fill} style={{ width: "45%" }}></div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent:'center',
                  marginBottom: "2em",
                  gap: "7.5em",
                  width: "90vw",
                }}
              >
                <img src="./images/materialui.png" style={{ height: "10vh" }} />
                <div className={classes.progress}>
                  <div className={classes.fill} style={{ width: "60%" }}></div>
                </div>
              </div>
            </Grid>

            {/* --------------------contact-------------------- */}

            <Grid items xs={12} style={{ marginTop: "2.5em"}} id={'section4'} data-aos="fade-up">
              <h2
                className={classes.heading4}
              >
                Contact
              </h2>
              <Divider
                style={{
                  backgroundColor: "#fbc531",
                  width: "14vw",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </Grid>
            <Grid items xs={12} data-aos="fade-up">
              <form>
                <div 
                style={{
                  display:'flex',
                  flexDirection:'column',
                  justifyContent:'center',
                  alignItems:'center',
                  marginTop:'5em'}}>
                  <Input placeholder="Full Name" className={classes.input} />
                  <Input placeholder="Email" className={classes.input} />
                  <TextareaAutosize placeholder="Message" minRows={10} className={classes.input1}/>
                  <span 
                    style={{
                      backgroundColor:'#0984e3',
                      width:'31vw',
                      margin:20,
                      height:'6vh',
                      display:'flex',
                      alignItems:'center',
                      justifyContent:'center',
                      borderRadius:'2em',
                      color:'#ffffff',
                      fontSize:'20px',
                      letterSpacing:2,
                      cursor:'pointer'
                    }}>
                    Send
                  </span>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
